new Vue({
    'el': '#app',

    data: {
        service_id: 0
    }
});